import { BaseAlgorithm } from './BaseAlgorithm';
import { CIDS } from '../../components/ProductsTable/constants';
import { debugLog, rankDebugLogEnable } from './ranking';

export class EsdProtectionAlgorithm extends BaseAlgorithm {
	constructor(usedFilters, filtersState) {
		super(usedFilters, filtersState);
		this.usedFilters = usedFilters;

		this.normVRWM = 12;
		this.normC = 90;

		this.rankVRWM = 0;
		this.rankC = 0;

		this.weightVRWM = 0.25;
		this.weightC = 0.25;

		this.rVRWM = 0;
		this.rC = 0;
	}

	logHeadingsToConsole() {
		if (rankDebugLogEnable) {
			console.log('partNumber,part_VRWM,rVRWM,rankVRWM,part_C,rC,rankC,feRank');
		}
	}

	execute(product) {
		debugLog.length = 0;
		debugLog.push(product[CIDS.PART_NUMBER]);

		// ---------------------------------------------Reverse Working Voltage  V_RWM Max (V)---------------------------------------------

		[this.rankVRWM, this.rVRWM] = this.calculateRankDualSliderGTE(CIDS.V_RWM_MAX, product, this.normVRWM);

		// ---------------------------------------------Diode Capacitance  C Max---------------------------------------------

		[this.rankC, this.rC] = this.calculateRankDualSliderGTE(CIDS.C_MAX, product, this.normC);

		// -------------------------------------------------------------------------------------------

		let feRank = this.weightVRWM * this.rankVRWM + this.weightC * this.rankC;
		let isPunished = false;
		debugLog.push(feRank);

		[feRank, isPunished] = super.punishPartsWithNullValueOfUsedFilters(product, this.usedFilters, feRank);

		let finalRank = (1 - this.weightVRWM - this.weightC) * super.execute(product) + feRank;

		return isPunished ? finalRank / this.maxRankAfterPunish : finalRank;
	}
}
